/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { DocumentVersionType } from '../../algorithm/types';
import FeedbackForm from './FeedbackForm';
import MedPearlOneFeedbackForm from './MedPearlOneFeedbackForm';
import { isMedPearlOne } from '../../permissions';
import { selectPearlUserInfo, selectShouldUserViewPilotFeedbackForm } from '../../Login/userSlice';
import { closeFeedback, selectShowFeedback, toggleFeedback } from './feedbackSlice';

export type DocumentVersionCommentButtonProps = {
  documentVersion?: DocumentVersionType;
};
export function DocumentVersionCommentButton({ documentVersion }: DocumentVersionCommentButtonProps) {
  const dispatch = useAppDispatch();
  const pearlUserInfo = useAppSelector(selectPearlUserInfo);
  const isMedPearlOneUser = isMedPearlOne(pearlUserInfo);
  const showFeedback = useAppSelector(selectShowFeedback);
  const shouldUserViewPilotFeedbackForm = useAppSelector(selectShouldUserViewPilotFeedbackForm);
  /* If you want to change the min-width, also set:
    $feedback-dialog-breakpoint in _sizes.scss
  */
  const isSmallScreen: boolean = !useMediaQuery('(min-width: 1000px)');

  const handleComment = () => {
    //make sure we dont have both feedback and comment active at the same time
    //if no active container exists then show the feedback container and set this to active
    dispatch(toggleFeedback());
  };
  useEffect(() => {
    //when navigating to a new document reset to the initial state
    dispatch(closeFeedback());
  }, [dispatch]);

  return (
    <>
      {shouldUserViewPilotFeedbackForm || isMedPearlOneUser ? (
        // Load a different feedback form for MedPearlOne or Consumer role users who are outside of Providence.
        <MedPearlOneFeedbackForm open={showFeedback} onClose={handleComment} />
      ) : (
        /* If the current screen resolution is below the defaults ,show it in a dialog */
        showFeedback &&
        (isSmallScreen ? (
          <Dialog open={true} onClose={handleComment} PaperProps={{ style: { background: 'var(--home-background)' } }}>
            <FeedbackForm documentVersion={documentVersion} onClose={handleComment} isSmallScreen={isSmallScreen} />
          </Dialog>
        ) : (
          <FeedbackForm documentVersion={documentVersion} onClose={handleComment} />
        ))
      )}
    </>
  );
}
